import { useState } from 'react';
import { H } from 'components';
import { PanelP03 } from '../intendendComponents';

const Prac03 = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <>
      <H level={3}>Almaty, Kazachstan</H>
      <PanelP03
        title="About"
        isActive={activeIndex === 0}
        onShow={() => setActiveIndex(0)}
      >
        With a population of about 2 million, Almaty is Kazakhstan's largest
        city. From 1929 to 1997, it was its capital city.
      </PanelP03>
      <PanelP03
        title="Etymology"
        isActive={activeIndex === 1}
        onShow={() => setActiveIndex(1)}
      >
        The name comes from <span lang="kk-KZ">алма</span>, the Kazakh word for
        "apple" and is often translated as "full of apples". In fact, the region
        surrounding Almaty is thought to be the ancestral home of the apple, and
        the wild <i lang="la">Malus sieversii</i> is considered a likely
        candidate for the ancestor of the modern domestic apple.
      </PanelP03>
    </>
  );
};

export default Prac03;
